import React, { Component } from "react";
import Slider from "../components/slider/slider";
class SliderContainer extends Component {
  render() {
    return <Slider />;
  }
}
export default SliderContainer;
